// src/components/AppRoutes.js
import React from "react";
import { Route, Switch } from "react-router-dom";
import CreateUserPage from "../pages/CreateUser";
import DownloadPage from "../pages/Download";
import DashboardPage from "../pages/Dashboard";
import HistoryListPage from "../pages/HistoryList";
import LoginPage from "../pages/Login";
import NotFound from "../pages/NotFound";
import RedirectPage from "../pages/Redirect";
import RedirectListPage from "../pages/RedirectList";
import ResetPage from "../pages/ResetPassword";
import StaffListPage from "../pages/StaffList";
import ReportsPage from "../pages/Reports";
import TenantListPage from "../pages/TenantList";
import PermissionGroupListPage from "../pages/PermissionGroupList";
import VisitorListPage from "../pages/VisitorList";
import AppointmentListPage from "../pages/AppointmentList";
import AccessCardPage from "../pages/AccessCard";
import AccessCardStaffPage from "../pages/AccessCardStaff";
import AccessListPage from "../pages/AccessList";
import NotificationListPage from "../pages/NotificationList";
import GuestRedirectPage from "../pages/GuestRedirect";
import PrivacyPolicyPage from "../pages/PrivacyPolicy";
import TurnstileMonitoring from "../pages/TurnstileMonitoring";
import VisitorSelfSubmission from "../pages/VisitorSelfSub";
import ContractorSelfSubmission from "../pages/ContractorSelfSub";
import ContractorList from "../pages/ContractorList";
import "../styles/app.scss";

export default class AppRoutes extends React.Component {
  render() {
    return (
      <div className="app-container">
        <Switch>
          <Route exact={true} path="/" component={LoginPage} />
          <Route path="/redirect" component={RedirectPage} />
          <Route path="/redirect-list" component={RedirectListPage} />
          <Route path="/login" component={LoginPage} />
          <Route path="/reset" component={ResetPage} />
          <Route path="/create-user" component={CreateUserPage} />
          <Route
            path="/download-file/:filestamp/:filename"
            component={DownloadPage}
          />

          <Route path="/dashboard" component={DashboardPage} />
          <Route path="/access-card" component={AccessCardPage} />
          <Route path="/staff-card" component={AccessCardStaffPage} />
          <Route path="/access-list" component={AccessListPage} />
          <Route path="/appointment-list" component={AppointmentListPage} />
          <Route path="/history-list" component={HistoryListPage} />
          <Route path="/user-list" component={StaffListPage} />
          <Route path="/tenant-list" component={TenantListPage} />
          <Route path="/permissions-list" component={PermissionGroupListPage} />
          <Route path="/visitor-list" component={VisitorListPage} />
          <Route path="/notification-list" component={NotificationListPage} />
          <Route path="/reports" component={ReportsPage} />
          <Route path="/guest" component={GuestRedirectPage} />
          <Route path="/monitoring" component={TurnstileMonitoring} />

          <Route path="/privacy-policy" component={PrivacyPolicyPage} />
          <Route path="/visitor" component={VisitorSelfSubmission} />
          <Route path="/contractor" component={ContractorSelfSubmission} />
          <Route path="/contractor-list" component={ContractorList} />

          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    );
  }
}
